import { ExternalDataService, PipelineChanges } from '@repo/roche-xx-shared';
import React, { useEffect, useRef, useState } from 'react';
import { cardiovascularNewLabel } from './roche-pipeline';

export const RochePipelineChanges = () => {
  const [content, setContent] = useState<PipelineChanges[] | null>(null);
  const tableRef = useRef<HTMLElement>(null);

  useEffect(() => {
    ExternalDataService.getPipelineChanges().then((response) => {
      setContent(response.Items);
    });
  }, []);

  // For EXTCWP-475 we need to update cardiovascular label. Unfortunately, this is hardcoded
  // in the roche-pipeline-changes-table. We decided to update it through a DOM hack, so
  // we don't need to create a new version of the component library.
  // Decision and details here: https://roche-ds.atlassian.net/browse/EXTCWP-475
  const updateLabel = () => {
    if (!tableRef.current) return; // table not rendered yet
    const shadow = (tableRef.current as HTMLElement).shadowRoot;
    if (!shadow) return; // table not rendered yet

    // this is a hardcoded selector, it might break if the table structure changes. so be careful.
    const labelEl = shadow.querySelector(
      'div.pipeline-row-container > div > ul > li:nth-child(5) > div.therapeutic-area-list__text',
    );
    if (labelEl && labelEl.textContent !== cardiovascularNewLabel) {
      labelEl.textContent = cardiovascularNewLabel;
    }
  };

  useEffect(() => {
    let observer: MutationObserver | null = null;

    if (tableRef.current) {
      const shadowElement = (tableRef.current as HTMLElement).shadowRoot;
      if (!shadowElement) {
        // Return a no-op cleanup.
        return () => {};
      }
      updateLabel();
      observer = new MutationObserver(() => {
        updateLabel();
      });
      observer.observe(shadowElement, { childList: true, subtree: true });
    }
    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [content]);

  if (!content) {
    return null;
  }

  return <roche-pipeline-changes-table ref={tableRef} content={JSON.stringify(content)} />;
};
